import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserIdleService } from 'angular-user-idle';
import { Subscription } from 'rxjs';
import { LoaderService } from './services/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy{
  title = 'life-premium-payment-web';
  isTimeout:boolean = false;
  showTimer:boolean = false;
  timeleft= 0;

  //Timeout Config
  //idle time before timer start
  idle=900;
  //timeout -=> timerduration
  timeout=60;

  
  showLoaderSubscription: Subscription;
  hideLoaderSubscription: Subscription;



  constructor(private userIdle: UserIdleService, private router:Router, 
    private loaderService:LoaderService, private cdr:ChangeDetectorRef){
    //timeout in secs
    this.userIdle.setConfigValues({idle:this.idle,timeout:this.timeout, ping:1});
     //Start watching for user inactivity.
     this.userIdle.startWatching();

     // Start watching when user idle is starting.
     this.userIdle.onTimerStart().subscribe(count => {
      if(count && count < this.timeout){
        this.showTimer = true;
        this.timeleft = this.timeout - count;
      }
     });

     // Start watch when time is up.
     this.userIdle.onTimeout().subscribe(() => {
      this.showTimer=false;
      this.isTimeout =true;
     });
     
    this.userIdle.resetTimer();
   }

  ngOnInit(): void {
    this.showLoaderSubscription = this.loaderService.showLoaderEvent$.subscribe((message:string)=>{
      this.showLoader();
    })
    this.hideLoaderSubscription = this.loaderService.hideLoaderEvent$.subscribe(()=> {
      this.hideLoader();
    });
  }

  ngOnDestroy(): void {
    if (this.showLoaderSubscription) {
      this.showLoaderSubscription.unsubscribe();
    }
    if (this.hideLoaderSubscription) {
      this.hideLoaderSubscription.unsubscribe();
    }
  }

  showLoader(){
    this.cdr.detectChanges();
    (document.getElementById("loader") as any)?.show();
  }

  hideLoader(){
    (document.getElementById("loader") as any)?.hide();
  }


  @HostListener('click', ['$event'])
  @HostListener('mouseover', ['$event'])
  @HostListener('keydown', ['$event'])
  @HostListener('mousemove', ['$event'])
  @HostListener('mousewheel', ['$event'])
  @HostListener('mousedown', ['$event'])
  @HostListener('touchstart', ['$event'])
  @HostListener('touchmove', ['$event'])
  @HostListener('scroll', ['$event'])

  public onEvent(event) {
    if (!this.showTimer && !this.isTimeout) {
      this.userIdle.resetTimer();
    }
  }

  public staySignedIn(){
    this.userIdle.resetTimer();
    this.showTimer=false;
  }

  public signInAgain(){
    this.router.navigateByUrl('/home');
    this.userIdle.resetTimer();
    this.isTimeout=false;
  }

}
